import { render, staticRenderFns } from "./end_success.vue?vue&type=template&id=2ba8e2cf&scoped=true"
import script from "./end_success.vue?vue&type=script&lang=js"
export * from "./end_success.vue?vue&type=script&lang=js"
import style0 from "./end_success.vue?vue&type=style&index=0&id=2ba8e2cf&prod&scoped=true&lang=less"
import style1 from "./end_success.vue?vue&type=style&index=1&id=2ba8e2cf&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba8e2cf",
  null
  
)

export default component.exports